import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { removeTypenameFromVariables } from "@apollo/client/link/remove-typename";
import { EnhancedStore } from '@reduxjs/toolkit';
//const origin = process.env.REACT_APP_GRAPHQL_ADDRESS ? process.env.REACT_APP_GRAPHQL_ADDRESS: `${window.location.protocol}//${window.location.hostname}:${process.env.REACT_APP_GRAPHQL_PORT ?? "4000"}` 
const baseOrigin = process.env.REACT_APP_GRAPHQL_ADDRESS ? process.env.REACT_APP_GRAPHQL_ADDRESS: `${window.location.protocol}//${window.location.hostname}/` 

const internalHttpLink = new HttpLink({
  uri: baseOrigin + 'internal/',
  fetchOptions: { mode: 'cors' }
})

const legacyHttpLink = new HttpLink({
  uri: baseOrigin + 'legacy/',
  fetchOptions: { mode: 'cors' }
})

const splitLink = ApolloLink.split(
  (operation) => {
    const context = operation.getContext()
    return context.clientName === 'legacy'
  },
  legacyHttpLink,    // if true → go to legacy
  internalHttpLink   // else → go to internal
)

const authLink = (store:EnhancedStore) => setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  
  var token = localStorage.getItem('token')
  var activeDomain = localStorage.getItem('activedomain')
  const activeDomainFromStore = store.getState().activeData.farm;
  const activedomain = activeDomainFromStore ?? activeDomain ?? "";
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': "true",
      token: process.env.REACT_APP_GRAPHQL_TOKEN?process.env.REACT_APP_GRAPHQL_TOKEN:'Very_Secret',
      authorization: token ? token : "",
      activedomain,
    }
  }
})

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        // controller: {
        //   merge(existing, incoming, {mergeObjects}) {
        //     return {...existing, ...incoming} //controllerLogsAico: [...existing.controllerLogsAico, ...incoming.controllerLogsAico]};
        //   }
        // }
        /*getOnlineState: {
          // Don't cache separate results based on any of this field's arguments.
          keyArgs: false,
          // Concatenate the incoming list items with the existing list items.
          merge(existing = [], incoming) {
            return [...existing, incoming]
          },
        }*/
      }
    },
    // ControllerQueries: {
    //   fields: {
    //     controllerLogsAico: {
    //       merge(existing, incoming) {
    //         console.debug(existing, incoming);
    //         return {...existing, ...incoming};
    //       }
    //     }
    //   }
    // }
  }
})

const removeTypenameLink = removeTypenameFromVariables();


export const setupApolloClient = (store: EnhancedStore ) => new ApolloClient({
  //uri: process.env.REACT_APP_GRAPHQL_ADDRESS,
  link: ApolloLink.from([authLink(store), removeTypenameLink, splitLink]), // authLink.concat(httpLink), ??
  cache: cache,
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
    }
  },
 
})
